import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M14 10v4a2 2 0 1 0 4 0v-4a2 2 0 1 0 -4 0","key":"svg-0"}],["path",{"d":"M6 8v3a1 1 0 0 0 1 1h3","key":"svg-1"}],["path",{"d":"M10 8v8","key":"svg-2"}]]

const IconNumber40Small = createReactComponent('outline', 'number-40-small', 'Number40Small', __iconNode);

export default IconNumber40Small;